import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import axios from 'axios'

import ForretningInvolvert from './ForretningInvolvert.jsx'
import CollapseIcon from '../../../images/expand copy 7.png'
import ExpandIcon from '../../../images/collapse copy 7.png'

class ForretningInvolvertList extends Component {
    state = {
        involverte: [],
        isLoading: false,
        isOpened: false,
        continuationToken: null        
    }

    getInvolverte = () => {
        this.setState({isLoading: true})
        axios.get(`${this.props.settings.baseUrl}api/forretning/${this.props.forretningId}/involvert`, {
            params: {
                token: this.props.token,
                size: 50,
                continuationToken: this.state.continuationToken                
            }
        })
        .then(({data}) => {
            this.setState({
                involverte: [...this.state.involverte, ...data.involverte],
                isLoading: false,
                continuationToken: data.nextContinuationToken
            })
        })
    }

    toggleInvolverte = () => {
        if (this.props.antall == 0) return

        if (this.state.involverte.length == 0) {
            this.getInvolverte()
        }

        this.setState({isOpened: !this.state.isOpened})
    }

    render() {
        const { t } = this.props
        var antallInvolverte = this.state.continuationToken ? `${this.state.involverte.length}/${this.props.antall}` : this.props.antall        
        return (
            <li>
                <div className="section-header" onClick={this.toggleInvolverte}>
                    { !this.state.isLoading &&
                        <span className="icon"><i className="fa fa-fw"></i></span>
                    }
                    {
                        this.state.isLoading &&
                        <span className="icon"><i className="fa fa-fw fa-spinner fa-spin"></i></span>
                    }
                    <span className="title">{t('involverte')} ({antallInvolverte})</span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                </div>
                <div className={this.state.isOpened && this.state.involverte.length > 0 ? "" : "collapsed"}>
                    <ul>
                        { this.state.involverte.map((i, index) => {return (<ForretningInvolvert key={i.arealIForretningId} involvert={i} antall={this.props.antall} isLast={index==this.state.involverte.length-1} />)}) }
                        { this.state.continuationToken &&
                        <li key="HentFlere">
                            <div className="section-header subsection button" onClick={this.getInvolverte}>
                                <span>{t('hent.involvert')}</span>
                            </div>
                        </li>
                        }
                    </ul>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(ForretningInvolvertList)